// Staff-only: the user whose email is `email`, from the portal's users table
// (GET /showman_admin/users searched by the address; the search is text, ranked with
// an exact match first). Pass the store's railsAPI, which always acts as the signed-in
// staff account, even while impersonating.
//
// Resolves {uid, email, user}, where user is the table's row (the id is the Firebase
// uid). A login whose signup never finished has no row, so it isn't found; nor is a
// walk-in or a deleted user. Rejects with an Error whose message can be shown as is.
const BY_STATUS = {
  401: 'Your session has expired. Sign in again.',
  403: 'Only Showman staff can look up accounts.'
}

export function lookupUserAccount (railsAPI, email) {
  const address = String(email || '').trim().toLowerCase()
  if (!address) return Promise.reject(new Error('Enter an email address.'))
  return railsAPI.get('/showman_admin/users', {params: {search: address, limit: 5}})
    .then(response => {
      // The search also matches a longer address that contains this one: take the exact one.
      // A duplicate address (an old row beside the live login) makes this pick whichever ranks first.
      const rows = (response.data && response.data.rows) || []
      const row = rows.find(candidate => String(candidate.email || '').toLowerCase() === address)
      if (!row) return Promise.reject(new Error(`No account found for ${email}`))
      return {uid: row.id, email: row.email, user: row}
    }, error => {
      const response = error.response
      const said = response && response.data && response.data.error
      if (said) return Promise.reject(new Error(said))
      if (response && BY_STATUS[response.status]) return Promise.reject(new Error(BY_STATUS[response.status]))
      if (response) return Promise.reject(new Error(`Account lookup failed (HTTP ${response.status}).`))
      return Promise.reject(error)
    })
}
